import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  outline: 0;\n  background: none;\n  border: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  transition: opacity 300ms;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:active {\n    opacity: 0.7;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PlayBtnSVG from '../assets/icons/play-btn.svg';
import styled from '../utils/styling/styled-components';
var PlayImage = styled.img(_templateObject());
var Button = styled.button(_templateObject2());

var PlayButton = function PlayButton(_ref) {
  var handleClick = _ref.handleClick,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Button, {
    className: className,
    onClick: handleClick,
    "aria-label": "Play"
  }, /*#__PURE__*/React.createElement(PlayImage, {
    src: PlayBtnSVG
  }));
};

export { PlayButton };